import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import WarehouseSelectModal from '../WarehouseSelectModal';
import { patchDevicesRequest } from '../../actions/devices';
import { patchSimcardsBatchRequest } from '../../actions/simcards';

function WarehouseAfterBatchModal({ 
  open, 
  onClose, 
  onSubmit, 
  type, 
  identifiers,
  patchDevicesRequest,
  patchSimcardsBatchRequest,
  isReadyForPatch,
  editFetching
}) {
  
  const [shouldCloseModal, setShouldCloseModal] = useState(false);
  const [selected, setSelected] = useState(null);
  const [warehouseId, setWarehouseId] = useState(null);
  const [loading, setLoading] = useState(false); 
  const isMounted = useRef(true);
  
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []); 


  useEffect(() => {
    if (selected && selected._id) {
      setWarehouseId(selected._id);
    } else {
      setWarehouseId(null);
    }
  }, [selected]);
  
  const [wasPreviouslyFetching, setWasPreviouslyFetching] = useState(false);
  
  useEffect(() => {
    
    if (wasPreviouslyFetching && !editFetching && isMounted.current) {
      
      setTimeout(() => {
        if (isMounted.current) {
          setShouldCloseModal(true);
        } 
      }, 1000); 
    }
    
    setWasPreviouslyFetching(editFetching);
  }, [editFetching, wasPreviouslyFetching]);
  
  useEffect(() => {
    if (shouldCloseModal && isMounted.current) {
      onClose();
    }
  }, [shouldCloseModal, onClose]);

  
  const [requestInProgress, setRequestInProgress] = useState(false);

  const handleContinue = async () => {
    
    if (requestInProgress) {
      return;
    }

    if (!warehouseId) {
      if (window.toast && window.toast.error) {
        window.toast.error('Por favor, selecciona una bodega');
      } else {
        alert('Por favor, selecciona una bodega');
      }
      return;
    }
    
    setRequestInProgress(true);
    setLoading(true);
    
    const payload = {};
    
    if (type === 'simcards') {
      payload.iccids = [...identifiers]; 
    } else {
      payload.imeis = [...identifiers];
    }

    payload.data = {
      status: 'bodega',
      substatus: {
        referenceModel: 'Warehouse',
        referenceId: warehouseId 
      }
    };
    
    try {
 
      if (type === 'simcards') {
        const options = {
          forceReload: true,
          showSuccessMessage: true
        };
        await patchSimcardsBatchRequest(payload, options);
      } else {
        await patchDevicesRequest(payload);
      }
      
      if (window.toast && window.toast.success) {
        window.toast.success(`${type === 'simcards' ? 'Simcards' : 'Dispositivos'} asignados a bodega correctamente`);
      }
      if (typeof onSubmit === 'function') {
        onSubmit(payload);
      }
      
    } catch (error) {
      if (window.toast && window.toast.error) {
        window.toast.error('Error al asignar la bodega. Por favor, inténtalo nuevamente.');
      } else {
        alert('Error al asignar la bodega. Por favor, inténtalo nuevamente.');
      }
    } finally {
      
      if (isMounted.current) {
        setLoading(false);
        setRequestInProgress(false);
      }
    }
  };

  const warehouseType = type === 'simcards' ? 'simcard' : 'device';
  
  const filtersToUseInQuery = {
    type: [warehouseType] 
  };
  
  
  return (
    <WarehouseSelectModal
      open={open}
      onClose={onClose}
      onContinue={handleContinue}
      selected={selected}
      setSelected={setSelected}
      filtersToUseInQuery={filtersToUseInQuery}
      loading={loading}
      disableContinue={!isReadyForPatch}
      continueButtonTooltip={!isReadyForPatch ? 'Esperando a que finalice la carga de datos' : ''}
      editFetching={editFetching}
    />
  );
}

const mapStateToProps = (state, ownProps) => {
  
  let isReadyForPatch = true;
  let editFetching = false;
  
  if (state.stock) {
    if (ownProps.type === 'simcards' && state.stock.simcards) {
      isReadyForPatch = state.stock.simcards.isReadyForPatch !== undefined ? state.stock.simcards.isReadyForPatch : true;
      editFetching = state.stock.simcards.editFetching || false;
    } else if (ownProps.type === 'devices' && state.stock.devices) {
      isReadyForPatch = state.stock.devices.isReadyForPatch !== undefined ? state.stock.devices.isReadyForPatch : true;
      editFetching = state.stock.devices.editFetching || false;
    }
  }
  
  return { isReadyForPatch, editFetching };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      patchDevicesRequest,
      patchSimcardsBatchRequest
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(WarehouseAfterBatchModal);

